import { render, staticRenderFns } from "./index.vue?vue&type=template&id=918cc1a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918cc1a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('918cc1a6')) {
      api.createRecord('918cc1a6', component.options)
    } else {
      api.reload('918cc1a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=918cc1a6&scoped=true", function () {
      api.rerender('918cc1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/label/index.vue"
export default component.exports